import { MapComponent } from "@inovitas/infra3dsdk/dist/types/mm";
import { Info, InfoOutlined } from "@mui/icons-material";
import { IconButton, ClickAwayListener, Box, Typography } from "@mui/material";
import { useState } from "react";
import { createPortal } from "react-dom";
import { defaultStore } from "../../common/stores/defaultStore";

export default function AttributionButton() {
  const showStreetMap = defaultStore((state) => state.showStreetMap);

  const [attributionOpen, setAttributionOpen] = useState(false);

  const handleOpenAttribution = () => {
    setAttributionOpen((prev) => !prev);
  };

  const getAttributions = () => {
    const viewer = defaultStore.getState().viewer;
    if (!viewer) return;
    const mapcomponent: MapComponent = viewer.getComponent("map");

    const layers = mapcomponent.map.olmap.getAllLayers();
    const visibleAttributions = new Set(
      layers.flatMap((layer) => layer.getAttributions())
    );

    return Array.from(visibleAttributions);
  };

  const button = (
    <>
      <IconButton
        id="infra3d-attribution-button"
        onClick={handleOpenAttribution}
        className="map-button"
        disableRipple={true}
        size="small"
        sx={{
          position: "absolute",
          bottom: "8px",
          right: "8px",
          backgroundColor: "darkblue.main",
          color: "white",
          ":hover": { color: "secondary.main" },
          padding: "3px",
        }}
      >
        {attributionOpen ? (
          <Info
            sx={{
              width: "0.75em",
              height: "0.75em",
            }}
          />
        ) : (
          <InfoOutlined
            sx={{
              width: "0.75em",
              height: "0.75em",
            }}
          />
        )}
      </IconButton>
      {attributionOpen && (
        <ClickAwayListener onClickAway={() => setAttributionOpen(false)}>
          <Box
            sx={{
              backgroundColor: "rgba(255,255,255, 0.9)",
              height: "16px",
              display: "flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              position: "absolute",
              bottom: "8px",
              right: "38px",
            }}
          >
            <Typography
              variant="body2"
              dangerouslySetInnerHTML={{
                __html: getAttributions()?.join(", ") || "",
              }}
              sx={{
                color: "darkblue.main",
                fontSize: "10px",
                lineHeight: "12px",

                "& a": {
                  color: "darkblue.main",
                },
              }}
            />
          </Box>
        </ClickAwayListener>
      )}
    </>
  );

  if (showStreetMap) {
    return createPortal(
      <div style={{ position: "fixed", bottom: 0, right: 0, width: "100%" }}>
        {button}
      </div>,
      document.body
    );
  }

  return (
    <div style={{ position: "absolute", bottom: 0, right: 0, width: "100%" }}>
      {button}
    </div>
  );
}
